export default "__VITE_ASSET__D6wqIid8__"